/* * @Author: jingyu.yang * @Date: 2022-01-10 15:56:20 * @Last Modified by:
jingyu.yang * @Last Modified time: 2022-01-10 16:09:35 */
<template>
  <div class="luckDraw" :data-i18n-locale="$i18n.locale" >
    <el-dialog ref="dialog" :visible="isShowLuck" :close-on-click-modal="false" class="dialog-dark luck"
      :title="$t('luckDraws.抽奖')" width="454px" @open="onOpen" @close="close">
      <el-form ref="luckDraw" :model="formLabelAlign" :rules="rules" :label-position="'right'" class="form-dark"
        size="mini" :label-width="labelWidth">
        <el-form-item :label="$t('luckDraws.奖品名称')" prop="title">
          <el-popover :value="isFoucs" :effect="'dark'" trigger="manual" popper-class="tip-popconfirm luck-tip-popconfirm"
            placement="bottom" :title="$t('luckDraws.参考名称')">
            <el-input ref="input" v-model="formLabelAlign.title" slot="reference" class="luck-title" type="text"
              :placeholder="$t('luckDraws.请输入')" maxlength="30" show-word-limit @focus="isFoucs = true"
              @blur="isFoucs = false"></el-input>
            <div class="luck-fastbox">
              <div v-for="item in lucks" :key="item" @click="setFast($t(`luckDraws.${item}`))">
                {{ $t(`luckDraws.${item}`) }}
              </div>
            </div>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$t('luckDraws.参与用户')" prop="candidatesRange">
          <el-select v-model="formLabelAlign.candidatesRange" popper-class="tip-select" :placeholder="$t('luckDraws.请选择')"
            @change="changeUser">
            <el-option v-for="item in options" ref="option" :key="item.value" :label="$t(`luckDraws.${item.label}`)"
              :value="item.value">
            </el-option>
          </el-select>
          <span v-if="formLabelAlign.candidatesRange !== '6'" class="luck-online input-tip">{{ $t("luckDraws.共") }}{{ total }}{{
            $t("luckDraws.人") }}</span>
        </el-form-item>
        <div class="import-user" v-if="formLabelAlign.candidatesRange === '3'">
          <Upload :file-name.sync="fileName" :total.sync="total" @changeUser="changeUser" />
          <a href="javascript:;" class="import" @click="importUsers">
            <svg width="10px" height="11px" viewBox="0 0 10 11" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>下载</title>
              <desc>Created with Sketch.</desc>
              <g id="主播端" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="组合抽奖-导入用户" transform="translate(-516.000000, -277.000000)" fill="#3986EE" class="main-color"
                  fill-rule="nonzero">
                  <g id="编组-6" transform="translate(321.000000, 116.000000)">
                    <path
                      d="M204.492326,170.61039 L195.507674,170.61039 C195.224321,170.61039 195,170.834711 195,171.118064 C195,171.401417 195.224321,171.625738 195.507674,171.625738 L204.492326,171.625738 C204.775679,171.625738 205,171.401417 205,171.118064 C205,170.846517 204.775679,170.61039 204.492326,170.61039 Z M199.663518,169.736718 C199.757969,169.831169 199.887839,169.878394 200.005903,169.866588 C200.123967,169.866588 200.253837,169.831169 200.348288,169.736718 L203.417946,166.66706 C203.595041,166.489965 203.595041,166.194805 203.417946,166.01771 C203.24085,165.840614 202.945691,165.840614 202.768595,166.01771 L200.442739,168.343566 L200.442739,161.460449 C200.442739,161.212515 200.242031,161 199.98229,161 C199.72255,161 199.521842,161.200708 199.521842,161.460449 L199.521842,168.29634 L197.243211,166.01771 C197.066116,165.840614 196.770956,165.840614 196.593861,166.01771 C196.416765,166.194805 196.416765,166.489965 196.593861,166.66706 L199.663518,169.736718 Z"
                      id="下载"></path>
                  </g>
                </g>
              </g>
            </svg>
            {{
              $t("luckDaw.下载模板")
            }}</a>
          <label class="file-name">
            <img :src="require('@/svg/file_icon.svg')" v-if="fileName" />{{
              fileName
            }}</label>
        </div>
        <el-form-item v-if="formLabelAlign.candidatesRange === '6'">
          <div class="tips-title">{{ $t("luckDraws.观看时长限制") }}:
            <el-select class="time-limit-input" v-model="formLabelAlign.raffleDuration.hour" size="small">
              <el-option v-for="item in hours()" :key="item.value" :label="item.lable" :value="item.value" />
            </el-select>
            <span class="time-limit-separator">:</span>
            <el-select class="time-limit-input" v-model="formLabelAlign.raffleDuration.minutes" size="small">
              <el-option v-for="item in minutes()" :key="item.value" :label="item.lable" :value="item.value" />
            </el-select>
            <span class="time-limit-separator">:</span>
            <el-select class="time-limit-input" v-model="formLabelAlign.raffleDuration.seconds" size="small">
              <el-option v-for="item in seconds()" :key="item.value" :label="item.lable" :value="item.value" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item v-if="formLabelAlign.candidatesRange === '4' ||
          formLabelAlign.candidatesRange === '5'
          ">
          <el-select v-model="formLabelAlign.rounds" popper-class="tip-select" :placeholder="$t('luckDraws.请选择')"
            @change="changeRounds">
            <el-option v-for="item in roundsSign" ref="roundsSign" :key="item.rounds" :label="item.stopTime"
              :value="item.rounds">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="formLabelAlign.candidatesRange === '5'">
          <el-select
            v-model="formLabelAlign.rounds"
            popper-class="tip-select"
            placeholder="$t('luckDraws.请选择')"
          >
            <el-option
              v-for="item in roundsQuestion"
              ref="roundsQuestion"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item class="luck-num" :label="$t('luckDraws.中奖人数')" prop="raffleCount">
          <el-input
            v-model="formLabelAlign.raffleCount"
            type="number"
            :placeholder="$t('luckDraws.请输入')"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            @blur="formLabelAlign.raffleCount = $event.target.value"
          ></el-input>
          <span v-if="formLabelAlign.candidatesRange !== '6'" class="luck-num-tip input-tip">{{
            $t("luckDraws.中奖人数不能超过参与用户人数")
          }}</span>
        </el-form-item>
        <el-form-item :rules="checkPreinstalluserRules" v-if="formLabelAlign.candidatesRange !== '6'"
          :label="$t('luckDraws.中奖预设')" prop="candidatesUsers">
          <el-autocomplete v-model="preinstalluser" :fetch-suggestions="searchonlineUserlist" :trigger-on-focus="false"
            class="auto-input" popper-class="tip-popconfirm tip-autocomplete" :placeholder="$t('luckDraws.请输入用户昵称快速搜索')"
            @select="selectLuckDrawsUser"></el-autocomplete>
          <div>
            <el-tag v-for="(tag, index) in selectPreinstalluser" :key="index" size="mini" type="info" closable
              style="margin-right: 5px" @close="closeselectPreinstall(tag)">
              {{ tag.value }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item :label="$t('luckDraws.自动下发')" prop="needCheck">
          <div class="form-item">
            <el-switch v-model="formLabelAlign.needCheck" :width="28" active-color="#2081EB" inactive-color="#5B617E">
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item :label="$t('luckDraws.中奖信息采集')">
          <div class="form-item">
            <div class="flex-1">
              <el-switch v-model="gotMoreSet" :width="28" active-color="#2081EB" inactive-color="#5B617E"
                :disabled="type == 3">
              </el-switch>
            </div>
            <el-link v-if="gotMoreSet && formLabelAlign.winnerVerifyInfo.length <= 4" type="primary"
              @click="addMoreList()">{{ $t("luckDraws.添加自定义选项") }}</el-link>
          </div>
        </el-form-item>
        <div class="moreSet" v-if="gotMoreSet">
          <div v-for="(moreSet, index) in formLabelAlign.winnerVerifyInfo" :key="'morelist' + index">
            <div v-if="moreSet.type">
              <el-form-item :key="'morelist' + index" :prop="'winnerVerifyInfo.' + index + '.infoType'" :rules="formRules"
                :label="$t(`luckDraws.${moreSet.infoType}`)" :label-width="moreSet.type ? '120px' : '85px'">
                <div class="flex-box">
                  <el-input v-model="moreSet.remark" :placeholder="$t(`luckDraws.${moreSet.remark}`)" :maxlength="100"
                    class="flex-1" disabled />
                  <a class="icon el-icon-delete" :title="$t('luckDraws.删除选项')" href="javascript:;"
                    @click="keyDelete(index)"></a>
                </div>
              </el-form-item>
            </div>
            <div class="flex-box" v-else>
              <el-form-item :prop="'winnerVerifyInfo.' + index + '.infoType'" :rules="formRules" :label="''"
                :label-width="'85px'" class="flex-1">
                <el-input v-model="moreSet.infoType" :maxlength="10" class="moreListStart"
                  :placeholder="$t('luckDraws.请填写字段名')" @input="filterSpace(moreSet, 'infoType')" />
              </el-form-item>
              <el-form-item :prop="'winnerVerifyInfo.' + index + '.remark'" :rules="formRules" :label="''"
                :label-width="'0px'" class="flex-1">
                <el-input v-model="moreSet.remark" :maxlength="10" class="moreListLong"
                  :placeholder="$t('luckDraws.请填写提示语')" @input="filterSpace(moreSet, 'remark')" />
                <a class="icon el-icon-delete" :title="$t('luckDraws.删除选项')" href="javascript:;"
                  @click="keyDelete(index)"></a>
              </el-form-item>
            </div>
          </div>
        </div>
        <el-form-item :label="$t('luckDraws.中奖用户排除')" prop="winnerExclusion">
          <div class="form-item">
            <el-switch v-model="formLabelAlign.winnerExclusion" :width="28" active-color="#2081EB"
              inactive-color="#5B617E" @change="changeRounds">
            </el-switch>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="sign-btn">
        <div>
          <el-link type="primary" @click="showHistory">
            {{ $t("luckDraws.抽奖记录") }}
          </el-link>
        </div>
        <div>
          <el-button :loading="isLoading" class="button-mini" type="primary" size="mini" @click="launchLuckDraws(true)">{{
            $t("luckDraws.开始抽奖") }}</el-button>
        </div>
      </div>
    </el-dialog>
    <LuckHistory :visible.sync="historyVisible" />
    <Lucking :visible.sync="luckingVisible" :config="config" @result="onResult" />
    <Lucked :visible.sync="luckedVisible" :raffleId.sync="raffleId" :config="config" @reluck="reluck" />
  </div>
</template>

<script>
import {
  Autocomplete,
  Dialog,
  Form,
  FormItem,
  Link,
  Popover,
  Switch,
  Tag,
  Tooltip,
} from "element-ui";
import LuckHistory from "./luck-history.vue";
import Lucked from "./lucked.vue";
import Lucking from "./lucking.vue";
import Upload from "./upload.vue";
import { mapGetters } from "vuex";
import { getCursorIndex, getParameter, downloadBlob } from "@/utils/global";
// import { getUserList } from "@/api/liveRequest/userApi";
import { getLuckUsers } from "@/api/liveRequest/luckDawApi";
import {
  getLuckCount,
  startLuckDraw,
  importUser,
  getRounds,
} from "@/api/liveRequest/luckDawApi";
// const luckInfo = [
//   { infoType: "姓名", remark: "请填写您的姓名", type: 1 },
//   { infoType: "手机", remark: "请填写您的手机", type: 2 },
// ];
export default {
  components: {
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Link.name]: Link,
    [Autocomplete.name]: Autocomplete,
    [Switch.name]: Switch,
    [Tag.name]: Tag,
    [Popover.name]: Popover,
    [Tooltip.name]: Tooltip,
    LuckHistory,
    Lucked,
    Lucking,
    Upload,
  },
  data() {
    var validatorNull = (rule, value, callback) => {
      value = value.trim();
      if (value == null || value == "" || value == undefined) {
        if (rule.field.endsWith(".remark")) {
          callback();
        } else {
          callback(new Error(this.$t("luckDraws.请输入字段名")));
        }
      } else {
        callback();
      }
    };
    var checkPreinstalluser = (rule, value, callback) => {
      if (value.length > this.formLabelAlign.raffleCount && this.formLabelAlign.candidatesRange !== 6) {
        callback(new Error(this.$t("luckDraws.预设人数不能大于中奖人数")));
      } else {
        callback();
      }
    };

    return {
      gotMoreSet: false,
      formLabelAlign: {
        webcastId: null, //场次id
        title: "", //抽奖标题
        candidatesRange: "0",
        candidatesUserId: [], //预设人列表
        candidatesUsers: [],
        raffleCount: "", //中奖人数
        needCheck: false, //自动下发默认否
        winnerVerifyInfo: [
          {
            infoType: "姓名",
            remark: this.$t("luckDraws.请填写您的姓名"),
            type: 1,
          },
          {
            infoType: "手机",
            remark: this.$t("luckDraws.请填写您的手机"),
            type: 2,
          },
        ],
        winnerExclusion: true,
        rounds: "",
        raffleDuration: {
          hour: 0,
          minutes: 0,
          seconds: 0,
        }
      },
      preinstalluser: null, //预设人员
      selectPreinstalluser: [],
      options: [
        {
          value: "0",
          label: "全部用户",
        },
        {
          value: "3",
          label: "导入用户",
        },
        {
          value: "4",
          label: "签到用户",
        },
        {
          value: "5",
          label: "问卷用户",
        },
        {
          value: "6",
          label: "长时间观看用户",
        },
      ],
      roundsSign: [],
      // roundsQuestion: [],

      formRules: {
        validator: validatorNull,
        trigger: "blur",
      },
      checkPreinstalluserRules: {
        validator: checkPreinstalluser,
        trigger: "blur",
      },
      raffleId: "", // 抽奖id
      historyVisible: false, // 抽奖历史弹窗
      luckedVisible: false,
      luckingVisible: false,
      // 参与用户人数
      total: 0,
      liveId: getParameter("liveId"),
      isFoucs: false,
      lucks: ["特等奖", "一等奖", "二等奖", "三等奖", "阳光普照奖"],
      isLoading: false,
      isBindEvent: false,
      config: {},
      fileName: "",
      type: 4,
      hours: () => {
        const array = [];
        for (let index = 0; index < 24; index++) {
          array.push({
            lable: index < 10 ? `0${index}` : `${index}`,
            value: index
          })
        }
        return array;
      },
      minutes: () => {
        const array = [];
        for (let index = 0; index < 60; index++) {
          array.push({
            lable: index < 10 ? `0${index}` : `${index}`,
            value: index
          })
        }
        return array;
      },
      seconds: () => {
        const array = [];
        for (let index = 0; index < 60; index++) {
          array.push({
            lable: index < 10 ? `0${index}` : `${index}`,
            value: index
          })
        }
        return array;
      }
    };
  },
  computed: {
    ...mapGetters([
      "isShowLuck",
      "all_user_online_count",
      "liveToken",
      "liveRoomStatus",
    ]),
    rules() {
      var checkLuckCount = (rule, value, callback) => {
        if (value > this.total && this.formLabelAlign.candidatesRange != 6) {
          callback(
            new Error(this.$t("luckDraws.中奖人数不能超过参与用户人数"))
          );
        } else if (value < 1) {
          this.formLabelAlign.raffleCount = "";
          callback(new Error(this.$t("luckDraws.请输入中奖人数")));
        } else {
          callback();
        }
      };
      return {
        title: [
          {
            required: true,
            message: this.$t("luckDraws.请输入奖品名称"),
            trigger: "blur",
          },
        ],
        candidatesRange: [
          {
            required: true,
            message: this.$t("luckDraws.请选择参与用户"),
            trigger: "blur",
          },
        ],
        raffleCount: [
          {
            required: true,
            message: this.$t("luckDraws.请输入中奖人数"),
            trigger: "blur",
          },
          { validator: checkLuckCount, trigger: "blur" },
        ],
        winnerVerifyInfo: [],
      };
    },
    onlineUserList() {
      return []; //this.$parent.$parent.$refs.onlineuserlist.userList;
    },
    labelWidth() {
      if (this.$i18n.locale === "en-US") {
        return "";
      } else {
        return "85px";
      }
    },
  },
  methods: {
    importUsers() {
      importUser()
        .then((resp) => {
          downloadBlob(resp, "", this.$t("luckDraws.导入用户模板") + ".xlsx");
        })
        .catch(() => {
          console.log("下载失败");
        });
    },
    onOpen() {
      this.slectUserRange("0");
      if (this.isBindEvent) {
        return;
      }
      this.isBindEvent = true;
      this.$nextTick(() => {
        this.$refs.option?.map((v) => {
          v.$el.addEventListener(
            "click",
            () => {
              this.slectUserRange(v.value);
            },
            false
          );
        });
      });
    },
    onClickOption(type) {
      console.log(type);
    },
    setFast(text) {
      const content = this.formLabelAlign.title;
      if ((content + text).length >= 30) return;
      const index = getCursorIndex(this.$refs.input?.$refs?.input);
      if (typeof index === "number") {
        const arr = content.split("");
        arr.splice(index, 0, text);
        this.formLabelAlign.title = arr.join("");
      } else {
        this.formLabelAlign.title = content + text;
      }
      this.checkRule("title");
    },
    // 点击抽奖历史
    showHistory() {
      this.historyVisible = true;
    },
    // 发起抽奖
    launchLuckDraws() {
      this.needLoading = true;
      if (this.liveRoomStatus != 2) {
        return this.$message.warning(this.$t("luckDraws.请先开启直播"));
      }
      this.$refs["luckDraw"].validate((valid) => {
        if (valid) {
          this.start();
        }
        // this.luckingVisible = valid;
      });
    },
    start() {
      this.isLoading = this.needLoading;
      console.log(this.formLabelAlign, "this.formLabelAlign");

      const config = Object.assign({}, this.formLabelAlign, {
        webcastId: this.$route.params.liveId,
      });
      if (!this.gotMoreSet) {
        delete config.winnerVerifyInfo;
      }
      if (this.formLabelAlign.candidatesRange === '6') {
        if (this.formLabelAlign.raffleDuration.hour === 0 && this.formLabelAlign.raffleDuration.minutes === 0) {
          this.isLoading = false;
          this.needLoading = false;
          return this.$message.warning(this.$t("luckDraws.观看时长必须大于1分钟"));
        }
        config.candidatesUserId = [];
        config.candidatesUsers = [];
      }
      //! 临时为了解决candidatesUsers莫名会多出一个空字符串的问题
      config.candidatesUsers = config.candidatesUsers.filter(element => element !== null && element !== "");
      //! 某些情况下needCheck会被改成[]导致抽奖接口报错，临时先增加类型判断，如果类型不是布尔值，强制改回布尔值
      if ('needCheck' in config && typeof config.needCheck !== "boolean") {
        config.needCheck = false;
      }
      startLuckDraw(config)
        .then(async (res) => {
          if (res?.code == 200 && res.data?.raffleId) {
            this.onResult(res.data.raffleId);
          } else {
            this.onResult(null);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 添加自定义选项 最多只能添加5个
    addMoreList() {
      this.formLabelAlign.winnerVerifyInfo.push({
        infoType: "",
        remark: "",
      });
    },
    // 删除用户信息采集
    keyDelete(index) {
      this.formLabelAlign.winnerVerifyInfo.splice(index, 1);
    },
    // 选择抽奖预设人员
    selectLuckDrawsUser(item) {
      console.log(item, "item");
      item.name = item.value;
      let user = this.formLabelAlign.candidatesUserId.find((info) => {
        return info == item.userId;
      });
      if (!user) {
        this.formLabelAlign.candidatesUserId.push(item.userId);
        this.formLabelAlign.candidatesUsers.push(item);
        this.selectPreinstalluser.push(item);
      }
      this.checkRule("candidatesUserId");
    },
    //搜索在线人员
    async searchonlineUserlist(queryString, cb) {
      const { code, data } = await getLuckUsers(
        {
          name: queryString,
          candidatesRange: this.formLabelAlign.candidatesRange,
          winnerExclusion: this.formLabelAlign.winnerExclusion,
          count: 50,
          rounds: this.formLabelAlign.rounds,
        },
        this.liveToken
      );
      if (code !== 200) {
        return cb([]);
      }
      var restaurants = data?.map((terminal) => {
        return {
          value: terminal.name,
          userId: terminal.userId,
          winningAlready: terminal.winningAlready,
        };
      });
      console.log(restaurants, "restaurants");
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      console.log(results, "results");
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value
          .toLowerCase()
          .includes(queryString.toLowerCase());
      };
    },
    closeselectPreinstall(tag) {
      let curdelIndex = this.selectPreinstalluser.findIndex((info) => {
        return info.userId == tag.userId;
      });
      if (curdelIndex != -1) {
        this.selectPreinstalluser.splice(curdelIndex, 1);
        this.formLabelAlign.candidatesUsers.splice(curdelIndex, 1);
        this.formLabelAlign.candidatesUserId.splice(curdelIndex, 1);
      }
      this.checkRule("candidatesUserId");
    },
    // 过滤空格
    filterSpace(info, type) {
      info[type] = info[type].trim();
    },
    onResult(prevId) {
      this.config = Object.assign({}, this.formLabelAlign);
      this.formLabelAlign.candidatesUserId = [];
      this.raffleId = prevId;
      this.luckedVisible = true;
      this.$store.commit("SET_SHOW_LUCK", false);
    },
    checkRule(name) {
      this.$refs.luckDraw?.validateField(name);
    },
    close() {
      this.$refs.luckDraw.resetFields();
      this.formLabelAlign.winnerVerifyInfo = [
        {
          infoType: "姓名",
          remark: this.$t("luckDraws.请填写您的姓名"),
          type: 1,
        },
        {
          infoType: "手机",
          remark: this.$t("luckDraws.请填写您的手机"),
          type: 2,
        },
      ];
      this.preinstalluser = null;
      this.selectPreinstalluser = [];
      this.gotMoreSet = false;
      this.$store.commit("SET_SHOW_LUCK", false);
    },
    reluck() {
      this.luckedVisible = false;
      this.$store.commit("SET_SHOW_LUCK", true);
    },
    slectUserRange(type) {
      console.log(type, "option");
      this.type = type;
      this.getLunkRounds(type);
      if (this.type !== 4 && this.type !== 5) {
        this.getLuckCount(type);
      }
      this.checkRule("candidatesRange");
    },
    async getLunkRounds(type) {
      if (type == 4 || type == 5) {
        const { code, data } = await getRounds({
          candidatesRange: type,
        });
        if (code === 200) {
          this.roundsSign = data;
          this.formLabelAlign.rounds = data.length > 0 ? data[0].rounds : "";
          this.getLuckCount(type);
        }
      }
    },
    async getLuckCount(type) {
      const { code, data } = await getLuckCount({
        webcastId: this.liveId,
        candidatesRange: type,
        winnerExclusion: this.formLabelAlign.winnerExclusion,
        rounds: this.formLabelAlign.rounds,
      });
      if (code === 200) {
        this.total = data;
        if (this.formLabelAlign.raffleCount !== undefined && this.formLabelAlign.raffleCount !== '') {
          this.checkRule('raffleCount');
        }
      }
    },
    changeRounds() {
      console.log(this.type, "change");
      console.log(this.formLabelAlign.rounds, "rounds");
      this.getLuckCount(this.type);
    },
    // 参会用户反正改变。中奖预设清空
    changeUser() {
      this.preinstalluser = null;
      this.selectPreinstalluser = [];
    },
  },
};
</script>
<style scoped lang="scss">
.time-limit-separator {
  padding: 0 5px;
}

.time-limit-input {
  width: 65px !important;
}

.luckDraw {
  margin-left: 100px;
  margin-top: 40px;
  text-align: left;

  &[data-i18n-locale="en-US"] {
    ::v-deep  .el-form-item {
      display: flex;

      .el-form-item__content {
        flex: 1;
      }
    }
  }
}

.moreListStart {
  width: 139px;
}

.moreListLong {
  width: 139px;
  margin-left: 10px;
}

.btn-blue-outline {
  border-radius: 4px;
}

.sign-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.link-blue {
  color: #2081eb;
  text-decoration: none;
}

.link-blue:hover {
  text-decoration: underline;
}

.luck_moreSet {
  margin-left: 40px;
}

.el-form-item__content .icon {
  width: 18px;
  height: 28px;
  line-height: 28px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  color: #ea494b;
  text-decoration: none;
}

.input-ground .input-titles {
  display: inline-block;
  text-align: right;
  width: 170px;
}

.form-item {
  height: 28px;
  line-height: 1;
  display: flex;
  align-items: center;

  .el-link {
    font-size: 12px;
  }
}

.luck-online {
  font-size: 12px;
  margin-left: 12px;
}

.luck-num {
  .el-input {
    width: 136px;
  }

  &-tip {
    font-size: 12px;
    margin-left: 12px;
  }
}

.luck-fastbox {
  display: flex;
  justify-content: space-between;

  >div {
    height: 34px;
    line-height: 32px;
    padding: 0 7px;
    border: 1px solid #444767;
    font-size: 12px;
    text-align: center;
    background: #202341;
    border-radius: 3px;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.auto-input {
  width: 100%;
}

.import-user {
  display: flex;
  padding: 0 0 20px 15px;
  .import {
    color: $bule-color;
    margin-left: 10px;
    text-decoration: auto;
  }
  .file-name {
    margin-left: 10px;
    color: #909399;
  }  
}
</style>

<style lang="scss">
.luck {
  .el-dialog__body {
    padding-right: 32px;
  }

  .el-select {
    width: 190px;
  }

  .el-input--mini .el-input__inner {
    padding: 0 8px;
    color: #fff;
    border-color: #525366;
  }

  .el-form-item--mini .el-form-item__error {
    padding-top: 4px;
  }

  .luck-title {
    &.el-input--mini .el-input__inner {
      padding-right: 50px;
      border-color: #525366;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .el-tag.el-tag--info {
    background-color: #212442;
    border-color: #acb2bf;
    color: #acb2bf;
  }
}

.luck-num {
  .el-input__inner {
    color: #fff;
    border-color: #525366;
  }
}

.luck-tip-popconfirm {
  padding: 10px;
  box-sizing: border-box;

  .popper__arrow {
    left: 20px !important;
  }
}
</style>
